import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import profileService from './profileService';


//Admin Profile Thunk Action Creator
export const profile = createAsyncThunk('admin/profile', async (_, {rejectWithValue}) => {
	try {
		const response = await profileService.profile();
		return response;
	} catch (error) {
		const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
		return rejectWithValue(message);
	}
});

//Admin Profile Thunk Action Creator
export const editProfile = createAsyncThunk('admin/profile/edit', async (data, {rejectWithValue}) => {
	try {
		const response = await profileService.editProfile(data);
		return response;
	} catch (error) {
		const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
		return rejectWithValue(message);
	}
});


const initialState = {
	profile:{},
	isError: false,
	isLoading: false,
	isSuccess: false,
	message: '',
	isEditSuccess: false,
	isEditLoading: false,
	isEditError: false,
};

export const profileSlice = createSlice({
	name: 'adminProfile',
	initialState,
	reducers: {
		reset: (state) => {
			state.isError = false;
			state.isSuccess = false;
			state.isLoading = false;
			state.message = '';
			state.isEditSuccess = false;
			state.isEditLoading = false;
			state.isEditError = false;
		},
		
	},
	extraReducers: (builder) => {
		builder
			.addCase(profile.pending, (state) => {
				state.isLoading = true;
			})
			.addCase(profile.fulfilled, (state, action) => {
				state.isLoading = false;
				state.isSuccess = true;
				state.profile = action.payload;
			})
			.addCase(profile.rejected, (state, action) => {
				state.isLoading = false;
				state.isError = true;
				state.message = action.payload;
				state.profile = null;
			})
			.addCase(editProfile.pending, (state) => {
				state.isEditLoading = true;
			})
			.addCase(editProfile.fulfilled, (state, action) => {
				state.isEditLoading = false;
				state.isEditSuccess = true;
				state.isEditError = false;
				state.message = action.payload.message;
			})
			.addCase(editProfile.rejected, (state, action) => {
				state.isEditLoading = false;
				state.isEditError = true;
				state.isEditSuccess = false;
				state.message = action.payload;
				
			})
		
	}
});

export const { reset } = profileSlice.actions;

export default profileSlice.reducer;